var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNextWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3942 4.74365L12.758 1.10734C12.6273 0.954808 12.3978 0.937027 12.2453 1.06768C12.0927 1.1983 12.0749 1.42786 12.2056 1.58039C12.2178 1.59461 12.231 1.60789 12.2453 1.62005L15.2597 4.63818H0.863618C0.66281 4.63818 0.5 4.80099 0.5 5.00183C0.5 5.20267 0.66281 5.36545 0.863618 5.36545H15.2597L12.2453 8.37992C12.0927 8.51055 12.0749 8.74011 12.2056 8.89263C12.3363 9.04516 12.5658 9.06294 12.7183 8.93229C12.7325 8.9201 12.7458 8.90685 12.758 8.89263L16.3943 5.25632C16.5352 5.11455 16.5352 4.88549 16.3942 4.74365Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNextWhite);
export default __webpack_public_path__ + "static/media/arrowNextWhite.8edac737376d7fab12922bc48e4456b3.svg";
export { ForwardRef as ReactComponent };